module.exports = __webpack_public_path__ + "img/extensioncaution.9b778d76.svg";